//@ts-nocheck
import { createGetRequest, createPostRequest } from 'lp-redux-api';
export const validateSSN = createPostRequest('VALIDATE_SSN', (resourceId, resourceType, validationType, validationInput) => ({
    url: '/consumer/v2/auth/validate',
    body: {
        resourceId,
        resourceType,
        validationType,
        validationInput,
    },
}));
export const applyAfterPrequalification = createPostRequest('APPLY_AFTER_PREQUALIFICATION', (application) => ({
    url: '/consumer_applications/v1/credit_applications/apply_after_prequalification',
    body: application,
}));
export const createCreditApplicationIdentityVerification = createPostRequest('CREATE_CREDIT_APPLICATION_IDENTITY_VERIFICATION', (creditApplicationId, creditApplicationData) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/identity_verification`,
    body: creditApplicationData,
}));
export const getCreditApplicationIdentityVerification = createGetRequest('GET_CREDIT_APPLICATION_IDENTITY_VERIFICATION', (creditApplicationId) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/identity_verification`,
}));
export const submitFullApplication = createPostRequest('POST_FULL_APPLICATION', (creditApplicationId, creditApplicationData) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/apply`,
    body: creditApplicationData,
}));
